export default "__VITE_ASSET__D7vPcxSl__"